<template>
  <div :class="[`icon-2`, className || ``]">
    <div class="overlap-group-10">
      <bg :src="bgProps.src" :className="bgProps.className" />
      <img
        class="shape-6"
        src="/otplanding/shape-4@2x.png"
        alt="Shape"
      />
    </div>
  </div>
</template>

<script>
import Bg from "./Bg";
export default {
  name: "Icon",
  components: {
    Bg,
  },
  props: ["className", "bgProps"],
};
</script>

<style>
.icon-2 {
  align-items: flex-start;
  display: flex;
  height: 64px;
  left: 131px;
  min-width: 64px;
  position: absolute;
  top: 0;
}

.overlap-group-10 {
  height: 64px;
  position: relative;
  width: 64px;
}

.shape-6 {
  height: 36px;
  left: 16px;
  position: absolute;
  top: 14px;
  width: 33px;
}

.icon-2.icon-3,
.icon-2.icon-5 {
  left: 130px;
}
</style>
